import { useEffect, useRef, useState } from "react";
import useLoading from "../../hooks/useLoading";
import useToast from "../../hooks/useToast";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { ArrowRightCircleIcon, EyeIcon, EyeSlashIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { FaSpinner } from "react-icons/fa";
import { isEmpty, isFunction } from "lodash";
import { resetAdminPass, resetPassword } from "../../services/ api_services";
import { ToastTypes } from "../../context/ToastProvider";
import axios from "axios";

export default function ResetPassDialog({ isOpen, onClose, userSeq, isAdmin }) {
    const { showToast } = useToast();
    const { loading, setLoading } = useLoading();

    const [pass, setPass] = useState("");
    const [showPass, setShowPass] = useState(false);

    const inputRef = useRef();

    useEffect(() => {
        onClear();
    }, []);

    const handleOnClose = () => {
        onClear();
        onClose();
    };

    const onClear = () => {
        setShowPass(false);
        setPass("");
    };

    const handleOnClickResetPass = async () => {
        //관리자
        if (isAdmin) {
            if (!isEmpty(userSeq)) {
                try {
                    setLoading(true);
                    console.log("PASS ==> ", pass);
                    console.log("USER SEQ ==> ", userSeq);
                    const data = {
                        userSeq: userSeq,
                        pass: pass,
                    };
                    console.log("🚀 ~ handleOnClickResetPass ~ data:", data);
                    let response;
                    if (isAdmin) {
                        response = await resetAdminPass(data);
                    } else {
                        response = await resetPassword(data);
                    }

                    // const ;
                    console.log("🚀 ~ handleOnClickResetPass ~ response:", response);
                    setLoading(false);
                    if (response && response.status === 200 && response.data && !isEmpty(response.data)) {
                        if (response.data.resultCode === 200) {
                            showToast(ToastTypes.SUCCESS, "성공", "비밀번호 재설정 완료했습니다.");
                            if (onClose && isFunction(onClose)) {
                                onClear();
                                onClose();
                            }
                        }
                    } else {
                        showToast(ToastTypes.ERROR, "실패", "비밀번호 재설정이 실패했습니다.");
                    }
                } catch (e) {
                    setLoading(false);
                    if (axios.isCancel(e)) {
                        console.log("요청이 취소되었습니다:", e.message);
                    } else {
                        console.error("Error reset pass: ", e);
                    }
                }
            }
        }
        //일반 사용자
        else {
        }
    };

    return (
        <Dialog as="div" className="relative z-10" onClose={() => handleOnClose()} open={isOpen}>
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
                    >
                        <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                            <button
                                type="button"
                                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                onClick={() => {
                                    handleOnClose();
                                }}
                            >
                                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                        </div>
                        <div className="sm:flex sm:items-start">
                            <div className="mt-3 text-center sm:ml-0 sm:mt-0 sm:text-left">
                                <DialogTitle as="h3" className="leading-6 font-semibold text-gray-900 text-xl">
                                    비밀번호 재설정하기
                                </DialogTitle>
                            </div>
                        </div>
                        <div className="pt-10">
                            <div className="flex">
                                <label className="block text-sm font-medium leading-6 text-gray-900">비밀번호</label>
                                <span className="text-sm text-red-700 leading-6 ml-1">*</span>
                            </div>

                            <div className="relative mt-2 rounded-md shadow-sm">
                                <input
                                    ref={inputRef}
                                    type={showPass ? "text" : "password"}
                                    className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    value={pass}
                                    maxLength={20}
                                    onChange={(e) => {
                                        setPass(e.target.value);
                                    }}
                                />
                                <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                    {!showPass && (
                                        <EyeIcon
                                            className="h-5 w-5 text-gray-400 cursor-pointer hover:text-gray-600"
                                            onClick={() => setShowPass(true)}
                                            aria-hidden="true"
                                        />
                                    )}
                                    {showPass && (
                                        <EyeSlashIcon
                                            className="h-5 w-5 text-gray-400 cursor-pointer hover:text-gray-600"
                                            onClick={() => setShowPass(false)}
                                            aria-hidden="true"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-end items-center">
                            <button
                                type="submit"
                                className="inline-flex items-center gap-x-1.5 rounded bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                                disabled={loading}
                                onClick={() => {
                                    handleOnClickResetPass();
                                }}
                            >
                                {loading ? (
                                    <FaSpinner className="spinnner" />
                                ) : (
                                    <ArrowRightCircleIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                )}
                                비밀번호 재설정하기
                            </button>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
}
